<template>
  <div>
    <!-- 导航栏，非全屏模式显示 -->
    <van-nav-bar v-if="!isFullscreen" style="position: fixed; top: 0; left: 0; width: 100%; background: url(/img/counter/top-bg.webp) no-repeat rgb(8, 76, 203);" :title="$t(gameName)" left-arrow @click-left="$router.back()">
      <template #right>
        <div @click="toggleFullscreen" style="color: white; margin-right: 15px; font-size: 16px; cursor: pointer;">
          {{ $t('全屏') }}
        </div>
      </template>
    </van-nav-bar>
    <div v-if="!isFullscreen" style="height: 46px"></div>
    
    <!-- 全屏模式下的退出按钮 -->
    <div v-if="isFullscreen" class="fullscreen-exit-btn" @click="toggleFullscreen">
      <span class="exit-arrow">↑</span>
    </div>
    
    <!-- 游戏内容 -->
    <div v-if="url" :style="isFullscreen ? 'height: 100vh; overflow: hidden;' : 'height: calc(100vh - 46px); overflow-y: scroll; -webkit-overflow-scrolling: touch'">
      <iframe :src="url" style="height: 100%; width: 100%" ref="iframe" scrolling="auto" frameborder="0" id="iframe"></iframe>
    </div>
    <div v-else class="game-entry-state" :style="isFullscreen ? 'height: 100vh;' : 'height: calc(100vh - 46px);'">
      <div v-if="loading || retrying" class="game-entry-message">
        <van-loading size="28px" vertical>{{ retrying ? '游戏余额正在同步，正在重试' : '正在进入游戏' }}</van-loading>
      </div>
      <div v-else class="game-entry-message game-entry-error">
        <div>{{ errorMessage || '进入游戏失败，请重新进入' }}</div>
        <van-button type="info" size="small" @click="retryGame">重新进入</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { normalizeLanguage } from '@/utils/language';

export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      gameName: '',
      isFullscreen: false,
      loading: false,
      retrying: false,
      errorMessage: '',
      retryTimer: null,
      requestSerial: 0,
      gameRequest: { name: '', type: '', code: '' },
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }
    if (query.app == 1) {
     that.url = that.$store.state.appInfo.ios_download_url;
      return;
    }
    if (query.name) {
      that.fetchGamesFromBackend(query.name, query.code || query.type);
      
      let gameName = query.game_name || query.title || query.gameTitle;
      if (!gameName) {
        const gameLists = [
          { name: 'fishingList', list: JSON.parse(localStorage.getItem('fishingList') || '[]') },
          { name: 'realbetList', list: JSON.parse(localStorage.getItem('realbetList') || '[]') },
          { name: 'sportList', list: JSON.parse(localStorage.getItem('sportList') || '[]') },
          { name: 'gamingList', list: JSON.parse(localStorage.getItem('gamingList') || '[]') },
          { name: 'jokerList', list: JSON.parse(localStorage.getItem('jokerList') || '[]') },
          { name: 'conciseList', list: JSON.parse(localStorage.getItem('conciseList') || '[]') },
          { name: 'lotteryList', list: JSON.parse(localStorage.getItem('lotteryList') || '[]') },
          { name: 'lhcList', list: JSON.parse(localStorage.getItem('lhcList') || '[]') },
          { name: 'jscList', list: JSON.parse(localStorage.getItem('jscList') || '[]') },
          { name: 'jwcList', list: JSON.parse(localStorage.getItem('jwcList') || '[]') },
          { name: 'qkcList', list: JSON.parse(localStorage.getItem('qkcList') || '[]') }
        ];
        
        const foundGames = [];
        for (const { name: listName, list } of gameLists) {
          const gameByCode = list.find(item => {
            const matchesPlatform = item.platform_name === query.name;
            const matchesCode = !query.type && !query.code || 
                              item.game_code === query.type || 
                              item.game_code === query.code;
            return matchesPlatform && matchesCode;
          });
          if (gameByCode) {
            foundGames.push({ source: 'code_match', list: listName, game: gameByCode });
          }
          const gameByPlatform = list.find(item => item.platform_name === query.name);
          if (gameByPlatform) {
            foundGames.push({ source: 'platform_match', list: listName, game: gameByPlatform });
          }
        }
        
        if (foundGames.length > 0) {
          foundGames.sort((a, b) => {
            if (a.source === 'code_match' && b.source !== 'code_match') return -1;
            if (a.source !== 'code_match' && b.source === 'code_match') return 1;
            return 0;
          });
          const bestMatch = foundGames[0].game;
          gameName = bestMatch.name || bestMatch.game_name || bestMatch.title;
        }
      }
      
      that.gameName = gameName || query.name;
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  methods: {
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    
    // 【修改核心】：打开游戏
    // 打开游戏
    goGamePage(name, type, code, attempt = 0) {
      let that = this;
      if (that.loading || that.retrying) return;
      that.gameRequest = { name: name, type: type, code: code };
      that.loading = true;
      that.errorMessage = '';
      const requestSerial = ++that.requestSerial;
      let currentLang = normalizeLanguage(that.$i18n.locale);
      let gameLanguage = (that.$store.state.appInfo && that.$store.state.appInfo.game_language) || currentLang;

      that.$apiFun
        .post('/api/getGameUrl', {
          plat_name: name,
          game_type: type || 0,
          game_code: code,
          is_mobile_url: 1,
          lang: gameLanguage,
        }, { timeout: 35000 })
        .then(res => {
          if (requestSerial !== that.requestSerial) return;
          that.loading = false;
          if (res.code != 200) {
            const retryable = res.code == 202 || (res.data && res.data.retryable);
            if (retryable && attempt < 2) {
              that.retrying = true;
              that.errorMessage = res.message || '游戏余额正在同步，请稍后重试';
              that.retryTimer = setTimeout(() => {
                that.retryTimer = null;
                that.retrying = false;
                that.goGamePage(name, type, code, attempt + 1);
              }, 2500);
              return;
            }
            that.errorMessage = res.message || '进入游戏失败，请重新进入';
            that.$parent.showTost(0, that.errorMessage);
          }
          if (res.code == 200) {
            if (!res.data || !res.data.url) {
              that.errorMessage = '三方没有返回游戏地址，请重新进入';
              that.$parent.showTost(0, that.errorMessage);
              return;
            }
            that.url = that.prepareGameUrl(name, res.data.url);

            if (res.data.game_name) {
              that.gameName = res.data.game_name;
            }
          }
        })
        .catch(() => {
          if (requestSerial !== that.requestSerial) return;
          that.loading = false;
          that.errorMessage = '进入游戏请求超时，请稍后点击重新进入';
          that.$parent.showTost(0, that.errorMessage);
        });
    },

    retryGame() {
      const request = this.gameRequest;
      if (request.name) {
        this.goGamePage(request.name, request.type, request.code);
      }
    },

    prepareGameUrl(platName, rawUrl) {
      if (!rawUrl) return rawUrl;
      if (String(platName).toUpperCase() !== 'PG') {
        return rawUrl;
      }
      let appInfo = {};
      try {
        appInfo = JSON.parse(localStorage.getItem('appInfo') || '{}');
      } catch (error) {
        appInfo = {};
      }
      const gameCurrency = String((this.$store.state.appInfo && this.$store.state.appInfo.game_currency) || appInfo.game_currency || '').toUpperCase();
      if (gameCurrency !== 'VND') {
        return rawUrl;
      }
      // PG 越南线没有 VI 皮肤，星汇返回的链接带 l=vi 时就会在 iframe 里报找不到界面
      return String(rawUrl).replace(
        /([?&#](?:l|lang|language)=)(vi|vn|vi-vn|vi_vn)/gi,
        '$1en'
      );
    },

    toggleFullscreen() {
      let that = this;
      if (!that.isFullscreen) {
        let elem = document.documentElement;
        if (elem.requestFullscreen) { elem.requestFullscreen(); } 
        else if (elem.webkitRequestFullscreen) { elem.webkitRequestFullscreen(); } 
        else if (elem.msRequestFullscreen) { elem.msRequestFullscreen(); }
        that.isFullscreen = true;
      } else {
        if (document.exitFullscreen) { document.exitFullscreen(); } 
        else if (document.webkitExitFullscreen) { document.webkitExitFullscreen(); } 
        else if (document.msExitFullscreen) { document.msExitFullscreen(); }
        that.isFullscreen = false;
      }
    },
    fetchGamesFromBackend(platformName, gameCode) {
      let that = this;
      const apiPaths = [
        '/api/game/list', 
        '/api/game/games', 
        '/api/games/list',
        '/api/game/game-lists', 
        '/api/game-lists', 
        '/api/game_lists' 
      ];
      let currentPathIndex = 0;
      
      const tryNextPath = () => {
        if (currentPathIndex >= apiPaths.length) return;
        const apiPath = apiPaths[currentPathIndex];
        currentPathIndex++;
        
        that.$apiFun.get(apiPath, { category: '' }).then(res => {
          if (res.code == 200 || res.status == 200) {
            let games = [];
            if (Array.isArray(res.data)) { games = res.data; } 
            else if (res.data && Array.isArray(res.data.list)) { games = res.data.list; } 
            else if (res.data && Array.isArray(res.data.games)) { games = res.data.games; } 
            else if (res.data && Array.isArray(res.data.game_lists)) { games = res.data.game_lists; }
            
            const gameByCode = games.find(item => {
              const matchesPlatform = item.platform_name === platformName || item.platform === platformName;
              const matchesCode = !gameCode || item.game_code === gameCode || item.code === gameCode || item.gameId === gameCode || item.type === gameCode;
              return matchesPlatform && matchesCode;
            });
            
            if (gameByCode) {
              that.gameName = gameByCode.name || gameByCode.game_name || gameByCode.title || gameByCode.gameName;
            } else {
              const gameByPlatform = games.find(item => item.platform_name === platformName || item.platform === platformName);
              if (gameByPlatform) {
                that.gameName = gameByPlatform.name || gameByPlatform.game_name || gameByPlatform.title || gameByPlatform.gameName;
              } else {
                const gameByCodeOnly = games.find(item => item.game_code === gameCode || item.code === gameCode || item.gameId === gameCode || item.type === gameCode);
                if (gameByCodeOnly) {
                  that.gameName = gameByCodeOnly.name || gameByCodeOnly.game_name || gameByCodeOnly.title || gameByCodeOnly.gameName;
                } else {
                  tryNextPath();
                }
              }
            }
          } else {
            tryNextPath();
          }
        }).catch(err => {
          tryNextPath();
        });
      };
      tryNextPath();
    },
  },
  beforeDestroy() {
    this.requestSerial++;
    if (this.retryTimer) {
      clearTimeout(this.retryTimer);
      this.retryTimer = null;
    }
  },
};
</script>

<style>
.van-nav-bar__arrow { color: white !important; }
.van-icon-arrow-left { color: white !important; }
.van-nav-bar__title { color: white !important; font-weight: bold !important; }
.fullscreen-exit-btn {
  position: fixed; top: 10px; right: 10px; width: 40px; height: 40px;
  background-color: rgba(0, 0, 0, 0.5); border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; z-index: 9999; transition: all 0.3s ease;
}
.fullscreen-exit-btn:hover { background-color: rgba(0, 0, 0, 0.7); transform: scale(1.1); }
.exit-arrow { color: white; font-size: 20px; font-weight: bold; }
.game-entry-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: #fff;
}
.game-entry-message {
  max-width: 320px;
  color: #666;
  text-align: center;
  line-height: 1.6;
}
.game-entry-error > div { margin-bottom: 16px; }
</style>



// WEBPACK FOOTER //
// src/components/mode/gamePage.vue